module.exports = __webpack_public_path__ + "static/media/btn-back-outline-wht.360a7c57.svg";